import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

const spacingValue = 0.75;

@Component({
  selector: 'wct-spacer',
  standalone: true,
  template: '',
  styleUrls: ['./spacer.component.scss'],
})
export class SpacerComponent {
  @HostBinding('style.padding.rem') protected style: number = spacingValue;

  @Input({ required: false }) public set spacingAmount(value: number) {
    const style: number = spacingValue * value;
    if (style !== this.style) {
      this.style = style;
      this.cdr.detectChanges();
    }
  }

  @Input({ required: false }) public set rem(value: number) {
    if (value !== this.style) {
      this.style = value;
      this.cdr.detectChanges();
    }
  }

  constructor(private readonly cdr: ChangeDetectorRef) {
    cdr.detach();
  }
}
